import { PosBookmarkUpdatePage } from '@/features/pos-bookmark/pages/PosBookmarkUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/pos-bookmark/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["pos_bookmark.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PosBookmarkUpdatePage,
})
